import { createContext, useContext, useState, ReactNode } from "react";
import { useNavigate } from "react-router-dom";

interface CompareContextType {
  selectedSlugs: string[];
  mainProductSlug: string;
  addSlug: (slug: string) => boolean;
  removeSlug: (slug: string) => void;
  navigateToCompare: () => void;
  selectedCount: number;
}

const CompareContext = createContext<CompareContextType | undefined>(undefined);

export const CompareProvider = ({
  children,
  mainProductSlug,
}: {
  children: ReactNode;
  mainProductSlug: any;
}) => {
  const [selectedSlugs, setSelectedSlugs] = useState<string[]>([]);
  const navigate = useNavigate();

  const addSlug = (slug: string) => {
    if (slug === mainProductSlug || selectedSlugs.includes(slug) || selectedSlugs.length >= 3) {
      return false;
    }
    setSelectedSlugs((prev) => [...prev, slug]);
    return true;
  };

  const removeSlug = (slug: string) => {
    setSelectedSlugs((prev) => prev.filter((s) => s !== slug));
  };

  const navigateToCompare = () => {
    const allSlugs = [mainProductSlug, ...selectedSlugs];
    if (allSlugs.length > 0) {
      const queryString = allSlugs.join(",");
      document.getElementById('close-compare')!.click();
      navigate(`/product/compare/${queryString}`);
    }
  };

  const selectedCount = selectedSlugs.length + 1;

  return (
    <CompareContext.Provider
      value={{ selectedSlugs, mainProductSlug, addSlug, removeSlug, navigateToCompare, selectedCount }}
    >
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error("useCompare must be used within a CompareProvider");
  }
  return context;
};